(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdown"] = factory();
	else
		root["@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdown"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 269);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MegaDropdown", function() { return MegaDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mega_dropdown_jss__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__range_picker_range_picker__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__range_picker_range_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__range_picker_range_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__columns_columns__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__columns_columns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__columns_columns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_images__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links_links__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links_links___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__links_links__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_icon__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icon_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__icon_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mega_dropdown_types__ = __webpack_require__(274);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MegaDropdown=function(_Component){_inherits(MegaDropdown,_Component);function MegaDropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MegaDropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MegaDropdown.__proto__||Object.getPrototypeOf(MegaDropdown)).call.apply(_ref,[this].concat(args))),_this),_this.renderRangePicker=function(ranges,links){var tmpLinks=links||[];if(!ranges){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__range_picker_range_picker___default.a,{ranges:ranges,links:tmpLinks}));},_this.onCrossesWrapperClick=function(ev,column){ev.stopPropagation();ev.preventDefault();var expandSubCategory=_this.props.expandSubCategory;expandSubCategory(column);},_this.renderColumns=function(columns){var _this$props=_this.props,classes=_this$props.classes,expandList=_this$props.expandList;var tmpColumns=columns||[];return tmpColumns.map(function(column,index){if(!column.title){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{key:'column-'+index,item:true,md:3,xs:12,className:classes.column},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__columns_columns___default.a,{column:column,expandList:expandList}),column.links.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.crossesWrapper,onClick:function onClick(ev){return _this.onCrossesWrapperClick(ev,column);}},(column.links&&column.links.some(function(l){return l.label;})||column.actionLinks&&column.actionLinks.some(function(l){return l.label;}))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icon_icon___default.a,{id:'dropicon',className:expandList===column.title?__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.buttonIcon):'',size:13}),expandList!==column.title));});},_this.renderImages=function(images){var classes=_this.props.classes;var tmpImages=images||[];return tmpImages.map(function(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{key:'image-'+index,item:true,md:3,xs:12,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.column,classes.imageColumn)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__images_images___default.a,{image:image}));});},_this.renderLinks=function(links){var tmpLinks=links||[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,md:3,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__links_links___default.a,{links:tmpLinks}));},_this.renderAdditionalColumn=function(columns){var classes=_this.props.classes;var tmpColumns=columns||[];return tmpColumns.map(function(column,index){if(!column.Image){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{key:'column-'+index,item:true,md:3,xs:12,className:classes.imageColumnAdditional},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__images_images___default.a,{image:column.Image}));});},_this.render=function(){var _this$props2=_this.props,classes=_this$props2.classes,expanded=_this$props2.expanded;var megaDropdown=_this.props.megaDropdown;var ranges=megaDropdown.ranges,links=megaDropdown.links,columns=megaDropdown.columns,images=megaDropdown.images;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.root,expanded&&classes.expanded)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true},ranges&&_this.renderRangePicker(ranges,links),columns&&_this.renderColumns(columns),images&&_this.renderImages(images),columns&&_this.renderAdditionalColumn(columns)));},_temp),_possibleConstructorReturn(_this,_ret);}return MegaDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MegaDropdown.displayName='MegaDropdown';MegaDropdown.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,megaDropdown:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_12__mega_dropdown_types__["a" /* MEGA_DROPDOWN_ITEM_PROP_TYPE */]).isRequired,expanded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,expandList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,expandSubCategory:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};MegaDropdown.defaultProps={expanded:false,expandList:''};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_6__mega_dropdown_jss__["a" /* default */])])(MegaDropdown));

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(theme){var _root,_column,_crossesWrapper;return{root:(_root={padding:theme.spacing.unit*2,height:100,display:'none',flexDirection:'column',flex:1,flexBasis:'auto',backgroundColor:theme.palette.background.paper,overflowY:'auto'},_defineProperty(_root,theme.breakpoints.up('sm'),{height:'auto'}),_defineProperty(_root,theme.breakpoints.up('md'),{position:'fixed',top:'100%',left:0,padding:theme.spacing.unit*2+'px '+theme.spacing.unit*4+'px '+theme.spacing.unit*2+'px '+theme.spacing.unit*3+'px',width:'100%',minHeight:80,boxShadow:'0 1px 3px 0 rgb(0 0 0 / 5%)'// theme.shadows[1]
}),_defineProperty(_root,theme.breakpoints.down('md'),{borderTop:'1px solid '+theme.palette.common.border}),_root),expanded:{display:'flex'},horizontalCross:{position:'absolute',top:'50%',transform:'translate3d(0,-50%,0) rotate(90deg)',content:'""',right:0,width:16,height:2,backgroundColor:'#10314c'},column:(_column={position:'relative'},_defineProperty(_column,theme.breakpoints.up('md'),{display:'flex',flexDirection:'column',flexBasis:'calc((100% - 96px)/4)',margin:theme.spacing.unit*5+'px '+theme.spacing.unit*4+'px '+theme.spacing.unit*5+'px 0'}),_defineProperty(_column,theme.breakpoints.down('md'),{marginBottom:theme.spacing.unit}),_defineProperty(_column,'&:last-child',_defineProperty({},theme.breakpoints.up('md'),{marginRight:0})),_column),crossesWrapper:(_crossesWrapper={display:'block',position:'absolute',width:30,height:20,top:0,right:0,zIndex:2},_defineProperty(_crossesWrapper,theme.breakpoints.up('md'),{display:'none'}),_defineProperty(_crossesWrapper,theme.breakpoints.down('md'),{textAlign:'right','& svg':{verticalAlign:'baseline'}}),_crossesWrapper),crosseWrapper2:{position:'relative',width:'100%',height:'100%'},verticalCross:{position:'absolute',top:'50%',transform:'translateY(-50%)',content:'""',right:0,width:16,height:2,backgroundColor:'#10314c'},imageColumn:_defineProperty({},theme.breakpoints.up('md'),{marginTop:theme.spacing.unit*4}),imageColumnAdditional:{marginRight:32},buttonIcon:{transform:'rotate(90deg)'}};});

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdownRangePicker");

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdownColumns");

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdownImages");

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MEGA_DROPDOWN_ITEM_PROP_TYPE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var MEGA_DROPDOWN_ITEM_PROP_TYPE={Id:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,links:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),ranges:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),columns:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),images:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object)};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/Grid");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/Icon");

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdownLinks");

/***/ })

/******/ });
});
//# sourceMappingURL=OneDaciaHeaderDesktopMenuMegaDropdown.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdown.js
// module id = 588
// module chunks = 0